import React, { useEffect, useState } from 'react';

const STORAGE_KEY = 'reports_currency_unit';

export default function CurrencyToggle({ onChange }) {
  const [unit, setUnit] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) || 'NGN'; } catch(e){ return 'NGN'; }
  });

  useEffect(() => {
    try { localStorage.setItem(STORAGE_KEY, unit); } catch(e){}
    if (onChange) onChange(unit);
  }, [unit, onChange]);

  return (
    <div style={{display:'inline-flex', alignItems:'center', gap:8}}>
      <label style={{marginRight:6}}>Currency</label>
      <select value={unit} onChange={(e) => setUnit(e.target.value)} className="form-control" style={{width:140}}>
        <option value="NGN">₦ (Naira)</option>
        <option value="KOBO">Kobo</option>
      </select>
    </div>
  );
}
